import { combineReducers } from 'redux';
import userReducer from './userReducer';
import contentReducer from './contentReducer';
import workspaceReducer from './workspaceReducer';
import entryReducer from './entryReducer';
import assetsReducer from './assetsReducer';
import appsReducer from './appStudioReducer';
import webHookReducer from './webHookReducer';
import promptReducer from './promptReducer';
import activityReducer from './activityReducer';
import oauthReducer from './oauthReducer';

// Combine Reducers
const rootReducer = combineReducers({
  user: userReducer,
  form: contentReducer,
  workspace: workspaceReducer,
  entry: entryReducer,
  assets:assetsReducer,
  apps:appsReducer,
  webhooks:webHookReducer,
  prompts:promptReducer,
  activity: activityReducer,
  oauth: oauthReducer,

  // Add other reducers here if you have more
});

export default rootReducer;